// Mono entry: serves all three apps behind the hostname/path dispatcher in
// App.tsx. This is what the `outclose` Pages project deploys; the per-app
// entries live in src/entry/ and retire this file once traffic cuts over.
import App from "./App";
import { renderRoot } from "./bootstrap";

renderRoot(<App />);
